import React, { useCallback, Ref } from 'react';
import HideableBox from '@prisjakt/ui-hideable-box';

import * as S from './styles';

type Props = {
  id: string;
  name: string;
  logo?: string;
  isOpen: boolean;
  onClickCategoryButton: (id: string) => void;
  buttonRef?: Ref<HTMLButtonElement>;
};

const TopLevelCategoryItem = ({
  id,
  name,
  logo,
  isOpen,
  onClickCategoryButton,
  buttonRef,
}: Props) => {
  const onClick = useCallback(() => onClickCategoryButton(id), [
    id,
    onClickCategoryButton,
  ]);

  return (
    <S.TopLevelItem>
      <S.TopLevelButton
        onClick={onClick}
        isOpen={isOpen}
        ref={buttonRef}
        aria-expanded={isOpen}
        aria-haspopup
        data-test="MegaMenuButton"
        data-test-id={id}
      >
        <S.TopLevelIcon src={logo} alt="" />
        <S.TopLevelCategoryName>{name}</S.TopLevelCategoryName>
        <HideableBox visible={isOpen}>
          <S.TopLevelArrow />
        </HideableBox>
      </S.TopLevelButton>
    </S.TopLevelItem>
  );
};

export default TopLevelCategoryItem;
